require('./bootstrap');
window.moment = require('moment');
